var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewZealandinline = function SvgNewZealandinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.402 0h30v30h-30V0Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.625 9.078v.806l1.611-.806h-1.611Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.97 9.973-.474-.652 1.777-.295-1.303.947Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.629 9.078v.806l-1.611-.806h1.61Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.284 9.973.474-.652-1.777-.295 1.303.947Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.086 9.412-.766.249 1.264 1.283-.498-1.532Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.339 10.015.474-.652.83 1.599-1.304-.947Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.168 9.412.766.249-.268-1.782-.498 1.533Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.125 9.362-.766.249.269-1.781.497 1.532Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.168 9.412.766.249-1.264 1.283.498-1.532Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.915 10.015-.474-.652-.83 1.599 1.304-.947Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.629 9.242v.533l1.064-.533H23.63Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.856 9.834-.313-.43 1.174-.196-.861.626Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.629 9.242v.533l-1.065-.533h1.065Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.402 9.834.313-.43-1.174-.196.861.626Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.934 9.463-.507.164.836.848-.33-1.012Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.441 9.861.313-.43.548 1.056-.861-.626Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.324 9.463.506.164-.177-1.177-.329 1.013Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.956 9.43-.507.164.177-1.177.33 1.013Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.32 9.463.507.164-.836.848.33-1.012Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.813 9.861-.313-.43-.548 1.056.86-.626Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.848 12.798v.717l1.433-.717h-1.433Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.152 13.595-.422-.58 1.582-.263-1.16.843Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.848 12.798v.717l-1.434-.717h1.434Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.544 13.595.42-.58-1.58-.263 1.16.843Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.258 13.095-.682.221 1.125 1.142-.443-1.363Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.594 13.631.422-.58.738 1.423-1.16-.843Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.441 13.095.682.221-.239-1.585-.443 1.364Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.291 13.05-.682.222.24-1.585.442 1.364Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.438 13.095.681.221-1.125 1.142.444-1.363Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.101 13.631-.421-.58-.739 1.423 1.16-.843Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.848 12.961v.444l.887-.444h-.887Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.038 13.455-.26-.36.978-.162-.718.522Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.848 12.961v.444l-.887-.444h.887Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.657 13.455.261-.36-.979-.162.718.522Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.102 13.146-.422.137.696.706-.274-.844Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.692 13.477.261-.358.457.88-.718-.522Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.594 13.146.422.137-.148-.981-.274.844Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.121 13.118-.422.137.148-.98.274.843Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.598 13.146.422.137-.697.706.275-.844Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.007 13.477-.26-.358-.458.88.718-.522Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.707 14.03v.806l1.611-.805h-1.611Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.052 14.926-.474-.652 1.777-.295-1.303.947Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.71 14.03v.806l-1.61-.805h1.61Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.366 14.926.474-.652-1.777-.295 1.303.947Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.168 14.365-.766.249 1.264 1.283-.498-1.532Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.421 14.968.474-.652.83 1.599-1.304-.947Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.25 14.364.766.25-.268-1.782-.498 1.532Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.208 14.315-.767.248.269-1.78.498 1.532Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.25 14.365.766.249-1.264 1.283.498-1.532Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.997 14.968-.474-.652-.83 1.599 1.304-.947Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.71 14.194v.533l1.066-.533H18.71Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.938 14.786-.313-.43 1.174-.196-.861.626Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.71 14.194v.533l-1.064-.533h1.065Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.484 14.786.313-.43-1.174-.196.861.626Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.016 14.415-.507.165.836.848-.33-1.013Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.523 14.813.313-.43.548 1.056-.861-.626Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.406 14.415.507.165-.178-1.178-.329 1.013Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.038 14.382-.507.164.178-1.177.329 1.013Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.402 14.415.507.165-.836.848.33-1.013Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.895 14.813-.313-.43-.548 1.056.86-.626Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.629 21.8v.895l1.788-.895H23.63Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.01 22.794-.526-.723 1.973-.328-1.447 1.051Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.629 21.8v.895L21.84 21.8h1.789Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.248 22.794.525-.723-1.972-.328 1.447 1.051Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.137 22.171-.85.277 1.402 1.424-.552-1.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.31 22.84.526-.723.921 1.775-1.447-1.051Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.121 22.171.85.277-.297-1.978-.553 1.701Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.183 22.116-.851.276.298-1.977.553 1.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.121 22.171.85.277-1.403 1.424.553-1.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.948 22.84-.526-.723-.922 1.775 1.448-1.051Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.629 21.965v.62l1.242-.62h-1.242Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.892 22.655-.365-.503 1.37-.227-1.005.73Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.629 21.965v.62l-1.242-.62h1.242Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.365 22.655.366-.503-1.37-.227 1.004.73Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.984 22.222-.59.192.974.99-.384-1.182Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.408 22.687.365-.502.64 1.232-1.005-.73Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.273 22.222.591.192-.207-1.373-.384 1.181Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.012 22.184-.59.191.207-1.373.383 1.182Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.273 22.222.591.192-.974.99.383-1.182Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.85 22.687-.366-.502-.64 1.232 1.005-.73Z",
    fill: "#CC142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.402 0h15v15h-15V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.402 0v1.875L9.836 7.5l5.566 5.479V15H13.44L7.844 9.492 2.394 15H.403v-1.992l5.45-5.479-5.45-5.361V0H2.22l5.625 5.508L13.293 0h2.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.793 9.492.322.996L1.633 15H.403v-.088l5.39-5.42Zm3.633-.351 1.582.234 4.394 4.307V15L9.426 9.14ZM15.402 0 9.777 5.742 9.66 4.453 14.055 0h1.347Zm-15 .03 5.655 5.536-1.729-.234L.402 1.436V.029Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.559 0v15h4.687V0H5.56ZM.402 5.156v4.688h15V5.156h-15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.402 6.094v2.812h15V6.094h-15ZM6.496 0v15H9.31V0H6.496Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.402,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#fff"
  })))));
};
export default SvgNewZealandinline;